import { Container, Row, Col, Image, Button, Card } from 'react-bootstrap';
import Footer from './components/Footer';

export default function Abstracts() {

  return (
    <>
      <section id="hero" className="hero hero-background position-relative">
        <Container >
          <Row className="align-items-center ">
              <Col md={8} lg={6} className=''>
                <h1 className="display-3 fw-bold text-white">Abstracts</h1>
              </Col>
            </Row>
        </Container>
      </section>
      <Container className='pb-5'>
        
        <Row className='my-5'>
          <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2  border-bpp-pink' data-aos="fade-up" data-aos-delay="50">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Abstract submission</span><br></br>May 15, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 border-2 border-bpp-pink' data-aos="fade-up" data-aos-delay="250">
                <Card.Body className='p-4'>
                <h6 className='m-0'><span className='text-bpp-pink'>Early Bird Registration</span><br></br>July 15, 2026</h6>
                </Card.Body>
              </Card>
            </Col>
        </Row>
        
        <Row className='align-items-center my-5'>
          <Col lg='6' className='pe-lg-5'>

          <div className="position-relative ps-4 pt-4">
            <Image src='images/abstracts-1.webp' className="img-fluid " data-aos="fade-right" data-aos-delay="50" />
            <div className="svg-overlay position-absolute"><Image src="images/bpp-02-h.svg" data-aos="fade-down" data-aos-delay="250"/></div>
          </div>
          </Col>
          <Col lg='6' className='py-5'>
            <h2 className='h1 my-5 purple-h'>How to Submit?</h2>
            <p>Authors are kindly invited to submit an abstract of <highlight>maximum one page</highlight> (DIN A4, approx. 300 words) prepared in Microsoft Word (Windows format). The abstract should be written in English using Aptos Display, 10-point font, and the text must be fully justified. Please use the following page margins: 2.5 cm (left, right, and bottom) and 4 cm (top), as shown in the template.</p>
            <p><highlight>Bibliographic references</highlight> should be cited as consecutive numbers in square brackets[1] within the text, and listed at the bottom of the abstract in Aptos Display, 8-point font, following the Vancouver style. <highlight>Figures, Schemes and Tables</highlight> are optional and can be inserted in the body of the text, providing that the overall length of the abstract is no longer than 1 page. If applicable, <highlight>acknowledgments</highlight> should be included at the end of the abstract under the heading ACKNOWLEDGMENTS.</p>
            <p>Please <highlight>save your file as:</highlight> Surname_Name_Type of contribution (oral or poster) Example: Surname_Name_oral.docx</p>
            <p>If you have any questions related to abstract submission, please contact BPP2026(at)ki.si.</p>
            <Button href="https://ec.europa.eu/eusurvey/runner/BPP2026_abstract_submission" target='_blank' variant="bpp-pink" size="lg" className='text-white mt-3 me-3'>Submit an abstract</Button>
             <Button href="files/BPP2026_Abstract template.docx" target='_blank' variant="outline-bpp-pink" size="lg" className='text-white_ mt-3'>Download template</Button>
             
          </Col>
        </Row>

        
        
      </Container>
      <Footer />
    </>
  );
}
 